<div class="exception-body error">
    <div class="particle elem1 anim-delay1"></div>
    <div class="particle elem2 anim-delay5"></div>
    <div class="particle elem3 anim-delay3"></div>
    <div class="particle elem4 anim-delay8"></div>
    <div class="particle elem5 anim-delay9"></div>
    <div class="particle elem6 anim-delay2"></div>
    <div class="particle elem7 anim-delay4"></div>
    <div class="exception-panel">
        <div class="exception-panel-content error">
            <h1>¡UPS!</h1>
            <span class="secondary">ERROR</span>
            <div class="information-text">
                <span><strong>Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde.</strong></span>
            </div>
        </div>
    </div>
</div>
